import { Component } from '@angular/core';
import { DialogModule } from 'primeng/dialog';
import { NgxJsonViewerModule } from 'ngx-json-viewer';
import { DialogService, DynamicDialogComponent, DynamicDialogRef } from 'primeng/dynamicdialog';

@Component({
  selector: 'hub-payload-details',
  standalone: true,
  imports: [DialogModule, NgxJsonViewerModule],
  template: `
    <div class="tw-flex tw-gap tw-flex-col">
      <span class="tw-font-bold">Entrada</span>
      <ngx-json-viewer [json]="inputPayload" />
      <span class="tw-font-bold">Saída</span>
      <ngx-json-viewer [json]="outputPayload" />
    </div>
  `,
  styleUrl: './payload-details.component.scss',
})
export class PayloadDetailsComponent {
  inputPayload = {};
  outputPayload = {};
  instance: DynamicDialogComponent;

  constructor(
    public ref: DynamicDialogRef,
    private dialogService: DialogService
  ) {
    this.instance = this.dialogService.getInstance(this.ref);
    this.inputPayload = this.dialogService.getInstance(this.ref).data.input;
    this.outputPayload = this.dialogService.getInstance(this.ref).data.output;
  }
}
